import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { mockGadgetSubmissions } from '../../data/mockData';
import { Search, Filter, Eye, Edit, X } from 'lucide-react';
import { GadgetSubmission } from '../../types';
const GadgetStatusBadge = ({
  status
}: {
  status: string;
}) => {
  switch (status) {
    case 'draft':
      return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-slate-100 text-slate-800" data-id="element-892">
          খসড়া
        </span>;
    case 'submitted':
      return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800" data-id="element-893">
          জমাদান করা হয়েছে
        </span>;
    case 'approved':
      return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800" data-id="element-894">
          অনুমোদিত
        </span>;
    case 'returned':
      return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-amber-100 text-amber-800" data-id="element-895">
          ফেরত
        </span>;
    case 'published':
      return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-teal-100 text-teal-800" data-id="element-896">
          প্রকাশিত
        </span>;
    default:
      return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-slate-100 text-slate-800" data-id="element-897">
          {status}
        </span>;
  }
};
export const ZsoSubmissionList: React.FC = () => {
  const {
    user
  } = useAuth();
  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('');
  const [viewModalData, setViewModalData] = useState<GadgetSubmission | null>(null);
  // Mocking current user's submissions
  const zsoSubmissions = mockGadgetSubmissions.filter(g => g.submittedBy === 'ZSO Jamalpur' || g.submittedBy === 'ZSO Dhaka');
  const filteredSubmissions = zsoSubmissions.filter(sub => {
    const matchesSearch = sub.id.toLowerCase().includes(searchTerm.toLowerCase()) || sub.district.toLowerCase().includes(searchTerm.toLowerCase()) || sub.upazila.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesStatus = statusFilter ? sub.status === statusFilter : true;
    return matchesSearch && matchesStatus;
  });
  const ViewModal = ({
    data
  }: {
    data: GadgetSubmission;
  }) => <div className="space-y-6" data-id="element-898">
      <div className="grid grid-cols-2 gap-4 mb-4" data-id="element-899">
        <div data-id="element-900">
          <p className="text-xs text-slate-500" data-id="element-901">গেজেট আইডি</p>
          <p className="font-medium" data-id="element-902">{data.id}</p>
        </div>
        <div data-id="element-903">
          <p className="text-xs text-slate-500" data-id="element-904">স্ট্যাটাস</p>
          <GadgetStatusBadge status={data.status} data-id="element-905" />
        </div>
        <div data-id="element-906">
          <p className="text-xs text-slate-500" data-id="element-907">অবস্থান</p>
          <p className="font-medium" data-id="element-908">
            {data.district}, {data.upazila}
          </p>
        </div>
        <div data-id="element-909">
          <p className="text-xs text-slate-500" data-id="element-910">তারিখ</p>
          <p className="font-medium" data-id="element-911">
            {new Date(data.submittedAt).toLocaleDateString('bn-BD')}
          </p>
        </div>
      </div>

      {data.status === 'returned' && data.returnRemarks && <div className="bg-amber-50 border border-amber-200 p-4 rounded-md" data-id="element-912">
          <p className="text-sm font-semibold text-amber-800 mb-1" data-id="element-913">
            ফেরত পাঠানোর কারণ:
          </p>
          <p className="text-sm text-amber-700" data-id="element-914">{data.returnRemarks}</p>
        </div>}

      <div className="border border-slate-200 rounded-md overflow-hidden" data-id="element-915">
        <div className="bg-slate-100 px-4 py-2 border-b border-slate-200 font-medium text-sm text-slate-700" data-id="element-916">
          মৌজা ও খতিয়ান তথ্য
        </div>
        <div className="overflow-x-auto" data-id="element-917">
          <table className="min-w-full divide-y divide-slate-200" data-id="element-918">
            <thead className="bg-slate-50" data-id="element-919">
              <tr data-id="element-920">
                <th className="px-3 py-2 text-left text-xs font-medium text-slate-500" data-id="element-921">
                  মৌজার নাম
                </th>
                <th className="px-3 py-2 text-left text-xs font-medium text-slate-500" data-id="element-922">
                  জে.এল. নম্বর
                </th>
                <th className="px-3 py-2 text-left text-xs font-medium text-slate-500" data-id="element-923">
                  শুরু নং
                </th>
                <th className="px-3 py-2 text-left text-xs font-medium text-slate-500" data-id="element-924">
                  শেষ নং
                </th>
                <th className="px-3 py-2 text-left text-xs font-medium text-slate-500" data-id="element-925">
                  খতিয়ান সংখ্যা
                </th>
                <th className="px-3 py-2 text-left text-xs font-medium text-slate-500" data-id="element-926">
                  শীট সংখ্যা
                </th>
                <th className="px-3 py-2 text-left text-xs font-medium text-slate-500" data-id="element-927">
                  মন্তব্য
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-slate-200" data-id="element-928">
              {data.moujaDetails.map((row, index) => <tr key={index} className={index % 2 === 0 ? 'bg-white' : 'bg-slate-50'} data-id="element-929">
                  <td className="px-3 py-2 text-sm text-slate-700" data-id="element-930">
                    {row.mouja}
                  </td>
                  <td className="px-3 py-2 text-sm text-slate-700" data-id="element-931">
                    {row.jlNumber}
                  </td>
                  <td className="px-3 py-2 text-sm text-slate-700" data-id="element-932">
                    {row.khatianStartNo || '—'}
                  </td>
                  <td className="px-3 py-2 text-sm text-slate-700" data-id="element-933">
                    {row.khatianEndNo || '—'}
                  </td>
                  <td className="px-3 py-2 text-sm text-slate-700" data-id="element-934">
                    {row.totalKhatian}
                  </td>
                  <td className="px-3 py-2 text-sm text-slate-700" data-id="element-935">
                    {row.totalSheet}
                  </td>
                  <td className="px-3 py-2 text-sm text-slate-700" data-id="element-936">
                    {row.remarks || '—'}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </div>;
  return <div className="max-w-7xl mx-auto" data-id="element-937">
      <div className="mb-6" data-id="element-938">
        <h1 className="text-2xl font-bold text-slate-900" data-id="element-939">
          গেজেট জমাদান তালিকা
        </h1>
        <p className="text-slate-500" data-id="element-940">
          আপনার দাখিলকৃত সকল গেজেট তথ্য দেখুন ও পরিচালনা করুন
        </p>
      </div>

      <div className="card overflow-hidden flex flex-col h-[calc(100vh-12rem)]" data-id="element-941">
        <div className="p-4 border-b border-slate-200 bg-slate-50 flex space-x-4" data-id="element-942">
          <div className="relative flex-1 max-w-md" data-id="element-943">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-slate-400" size={18} data-id="element-944" />
            <input type="text" placeholder="আইডি বা অবস্থান দিয়ে অনুসন্ধান..." className="input-field pl-10 text-sm" value={searchTerm} onChange={e => setSearchTerm(e.target.value)} data-id="element-945" />
          </div>
          <select className="input-field w-48 text-sm" value={statusFilter} onChange={e => setStatusFilter(e.target.value)} data-id="element-946">
            <option value="" data-id="element-947">সকল স্ট্যাটাস</option>
            <option value="draft" data-id="element-948">খসড়া</option>
            <option value="submitted" data-id="element-949">জমাদান করা হয়েছে</option>
            <option value="approved" data-id="element-950">অনুমোদিত</option>
            <option value="returned" data-id="element-951">ফেরত</option>
            <option value="published" data-id="element-952">প্রকাশিত</option>
          </select>
          <button className="btn-secondary flex items-center text-sm" data-id="element-953">
            <Filter size={16} className="mr-2" data-id="element-954" /> আরও ফিল্টার
          </button>
        </div>

        <div className="flex-1 overflow-auto" data-id="element-955">
          <table className="min-w-full divide-y divide-slate-200" data-id="element-956">
            <thead className="bg-slate-50 sticky top-0 z-10" data-id="element-957">
              <tr data-id="element-958">
                <th className="px-4 py-3 text-left text-xs font-medium text-slate-500 uppercase" data-id="element-959">
                  আইডি
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-slate-500 uppercase" data-id="element-960">
                  জেলা
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-slate-500 uppercase" data-id="element-961">
                  উপজেলা
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-slate-500 uppercase" data-id="element-962">
                  মৌজা সংখ্যা
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-slate-500 uppercase" data-id="element-963">
                  তারিখ
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-slate-500 uppercase" data-id="element-964">
                  স্ট্যাটাস
                </th>
                <th className="px-4 py-3 text-right text-xs font-medium text-slate-500 uppercase" data-id="element-965">
                  কার্যক্রম
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-slate-200" data-id="element-966">
              {filteredSubmissions.map(sub => <tr key={sub.id} className="hover:bg-slate-50" data-id="element-967">
                  <td className="px-4 py-3 whitespace-nowrap text-sm font-medium text-slate-900" data-id="element-968">
                    {sub.id}
                  </td>
                  <td className="px-4 py-3 whitespace-nowrap text-sm text-slate-600" data-id="element-969">
                    {sub.district}
                  </td>
                  <td className="px-4 py-3 whitespace-nowrap text-sm text-slate-600" data-id="element-970">
                    {sub.upazila}
                  </td>
                  <td className="px-4 py-3 whitespace-nowrap text-sm text-slate-500" data-id="element-971">
                    {sub.moujaDetails.length}
                  </td>
                  <td className="px-4 py-3 whitespace-nowrap text-sm text-slate-500" data-id="element-972">
                    {new Date(sub.submittedAt).toLocaleDateString('bn-BD')}
                  </td>
                  <td className="px-4 py-3 whitespace-nowrap" data-id="element-973">
                    <GadgetStatusBadge status={sub.status} data-id="element-974" />
                  </td>
                  <td className="px-4 py-3 whitespace-nowrap text-right text-sm font-medium space-x-2" data-id="element-975">
                    <button onClick={() => setViewModalData(sub)} className="text-blue-600 hover:text-blue-900 p-1 bg-blue-50 rounded" title="দেখুন" data-id="element-976">
                      <Eye size={16} data-id="element-977" />
                    </button>
                    {(sub.status === 'draft' || sub.status === 'returned') && <button className="text-amber-600 hover:text-amber-900 p-1 bg-amber-50 rounded" title="সম্পাদনা" data-id="element-978">
                        <Edit size={16} data-id="element-979" />
                      </button>}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>

      {viewModalData && <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4" data-id="element-980">
          <div className="bg-white rounded-lg shadow-xl w-full max-w-4xl max-h-[90vh] flex flex-col" data-id="element-981">
            <div className="p-4 border-b border-slate-200 flex justify-between items-center bg-slate-50 rounded-t-lg" data-id="element-982">
              <h2 className="text-lg font-bold text-slate-800" data-id="element-983">
                গেজেট দেখুন — {viewModalData.id}
              </h2>
              <button onClick={() => setViewModalData(null)} className="text-slate-400 hover:text-slate-600" data-id="element-984">
                <X size={20} data-id="element-985" />
              </button>
            </div>
            <div className="p-6 overflow-y-auto flex-1" data-id="element-986">
              <ViewModal data={viewModalData} data-id="element-987" />
            </div>
            <div className="p-4 border-t border-slate-200 bg-slate-50 rounded-b-lg flex justify-end" data-id="element-988">
              <button onClick={() => setViewModalData(null)} className="btn-secondary" data-id="element-989">
                বন্ধ করুন
              </button>
            </div>
          </div>
        </div>}
    </div>;
};